<template>
    <div ref="container" class="btn-group">
        <button ref="button" type="button" class="btn bg-white border dropdown-toggle" :class="{ show: isOpen }"
            :aria-expanded="isOpen ? 'true' : 'false'" @click="toggleDropdown">
            <span v-if="selectedBalise">
                <img :src="`/img/cars/` + selectedBalise.icon" :style="{ height: '32px' }" class="sm me-2">

                <small class="text-muted">
                    {{ selectedBalise.name }}
                </small>
            </span>

            <small v-else class="text-muted">
                Véhicules...
            </small>
        </button>


        <Teleport to="body">

            <ul v-if="isOpen" ref="menu" class="dropdown-menu show balise-dropdown-menu" :style="menuStyle">
                <li v-for="balise in balises" :key="balise.id">
                    <button type="button" class="dropdown-item" @click="selectBalise(balise)">
                        <img :src="`/img/cars/` + balise.icon" :style="{ height: '32px' }" class="sm me-2">

                        <small class="text-muted">
                            {{ balise.name }}
                        </small>
                    </button>
                </li>
            </ul>

        </Teleport>

    </div>
</template>


<script>
import BaliseService from '@/services/balise.service.js'
import FormatHelper from '@/helpers/format.helper.js'

export default {

    props: {
        selectedBaliseId: [String, Number],

        /*
         * Conservé pour compatibilité avec les pages
         * utilisant déjà cette prop.
         */
        dropdownMode: {
            type: String,
            default: 'floating',
            validator: v => ['floating', 'fixed'].includes(v)
        }
    },

    emits: ['baliseChange'],

    data() {
        return {
            balises: null,
            selectedBalise: null,

            isOpen: false,

            menuStyle: {
                position: 'fixed',
                top: '0px',
                left: '0px',
                minWidth: '0px',
                maxHeight: '420px',
                zIndex: 1080
            }
        }
    },

    watch: {

        selectedBaliseId() {
            this.setSelectedBalise(this.selectedBaliseId);
        }

    },

    mounted() {

        this.getBalises();

        document.addEventListener(
            'mousedown',
            this.handleOutsideClick
        );

        window.addEventListener(
            'resize',
            this.updateMenuPosition
        );

        window.addEventListener(
            'scroll',
            this.updateMenuPosition,
            true
        );
    },

    beforeUnmount() {

        document.removeEventListener(
            'mousedown',
            this.handleOutsideClick
        );

        window.removeEventListener(
            'resize',
            this.updateMenuPosition
        );

        window.removeEventListener(
            'scroll',
            this.updateMenuPosition,
            true
        );
    },

    methods: {

        getBalises() {

            BaliseService.getGroupBalisesLastPositions()
                .then(response => {

                    this.balises =
                        FormatHelper.balisesResponseFormat(
                            response.data
                        );

                    this.setSelectedBalise(
                        this.selectedBaliseId
                    );

                    this.$emit(
                        'baliseChange',
                        this.selectedBalise
                    );
                })
                .catch(e => {
                    console.log(e);
                });
        },


        setSelectedBalise(bId) {

            if (
                this.balises == null ||
                bId == null
            ) {
                this.selectedBalise = null;
                return;
            }

            this.selectedBalise =
                this.balises.find(
                    balise => balise.id == bId
                ) || null;
        },


        toggleDropdown() {

            this.isOpen = !this.isOpen;

            if (this.isOpen) {

                this.$nextTick(() => {
                    this.updateMenuPosition();
                });
            }
        },


        selectBalise(balise) {

            this.selectedBalise = balise;

            this.isOpen = false;

            this.$emit(
                'baliseChange',
                balise
            );
        },


        updateMenuPosition() {

            if (
                !this.isOpen ||
                !this.$refs.button
            ) {
                return;
            }

            const rect =
                this.$refs.button.getBoundingClientRect();

            const viewportHeight =
                window.innerHeight;

            const viewportWidth =
                window.innerWidth;

            const margin = 12;


            /*
             * Espace disponible verticalement.
             */
            const availableBelow =
                viewportHeight -
                rect.bottom -
                margin;

            const availableAbove =
                rect.top -
                margin;


            const openAbove =
                availableBelow < 200 &&
                availableAbove > availableBelow;


            const availableHeight =
                openAbove
                    ? availableAbove
                    : availableBelow;


            const maxHeight =
                Math.max(
                    120,
                    Math.min(
                        420,
                        availableHeight
                    )
                );


            /*
             * Largeur réelle souhaitée par le menu.
             */
            const menuWidth =
                Math.min(
                    Math.max(
                        rect.width,
                        this.$refs.menu?.scrollWidth || rect.width
                    ),
                    viewportWidth - (margin * 2)
                );


            /*
             * Par défaut, le menu démarre au même endroit
             * que le bouton.
             */
            let left = rect.left;


            /*
             * S'il dépasse à droite, on le décale vers la gauche.
             */
            if (
                left + menuWidth >
                viewportWidth - margin
            ) {
                left =
                    viewportWidth -
                    margin -
                    menuWidth;
            }


            /*
             * Sécurité côté gauche.
             */
            left =
                Math.max(
                    margin,
                    left
                );


            this.menuStyle = {
                position: 'fixed',

                left:
                    `${left}px`,

                top:
                    openAbove
                        ? 'auto'
                        : `${rect.bottom + 2}px`,

                bottom:
                    openAbove
                        ? `${viewportHeight - rect.top + 2}px`
                        : 'auto',

                width:
                    `${menuWidth}px`,

                maxWidth:
                    `calc(100vw - ${margin * 2}px)`,

                maxHeight:
                    `${maxHeight}px`,

                zIndex: 1080
            };
        },


        handleOutsideClick(event) {

            if (!this.isOpen) {
                return;
            }

            const clickedButton =
                this.$refs.container?.contains(
                    event.target
                );

            const clickedMenu =
                this.$refs.menu?.contains(
                    event.target
                );

            if (
                !clickedButton &&
                !clickedMenu
            ) {
                this.isOpen = false;
            }
        }

    }
}
</script>


<style scoped>
.balise-dropdown-menu {
    overflow-y: auto;
    overflow-x: hidden;

    margin: 0;

    overscroll-behavior: contain;

    box-shadow:
        0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.balise-dropdown-menu .dropdown-item {
    display: flex;
    align-items: center;

    width: 100%;

    padding-top: 0.45rem;
    padding-bottom: 0.45rem;

    border: 0;

    background: transparent;
}

.balise-dropdown-menu .dropdown-item:hover {
    background: var(--bs-tertiary-bg);
}
</style>